<div class="indent" fxLayout="column" [ngStyle]="componentStyle">
  <div class="checkbox-container" *ngIf="!hideCheckAll">
    <mat-checkbox
      class="main-indent "
      [checked]="checkedAll"
      (change)="changeAll()"
      aria-label="Zaznacz wszystkie oświadczenia"
      appGtmFormEvent>
      <span class="cdk-visually-hidden">Zaznacz wszystkie oświadczenia</span>
    </mat-checkbox>

    <div class="consent-text-all h3-regular">

      <p id="checkAllLabel" style="line-height: 20px" class="left-text">Zaznacz wszystkie oświadczenia</p>
      <button *ngIf="!toggled" (click)="toggle()" class="right-button h3-regular" mat-raised-button extended>
        Rozwiń
        <app-icon name="expand_more" [height]="12" [width]="12"></app-icon>
      </button>
      <button *ngIf="toggled" class="right-button h3-regular" (click)="toggle()"   mat-raised-button extended>
        Zwiń
        <app-icon name="expand_less" [height]="12" [width]="12"></app-icon>
      </button>

    </div>
  </div>

  <ng-container *ngIf="toggled">
    <ng-container *ngFor="let item of statements; let i = index">
      <div class="h3-regular" [style.padding-left]="hideCheckAll ? '0' : '15px'"
           [id]="'statement_'+item.id" #statement
           [class.error]="!isChecked(item.id) && item.required && isTouched(item.id)">
        <div class="checkbox-container">
          <mat-checkbox
            aria-label="{{'Zaznacz oświadczenie ' +  item.name}}}"
            class="indent"
            [checked]="isChecked(item.id)"
            (change)="markAsTouched(); toggleCheckbox(item.id)"
            appGtmFormEvent>

            <span class="cdk-visually-hidden">Zaznacz wszystkie oświadczenia</span>
          </mat-checkbox>
          <div class="consent-text "
               [class.accent-color]="isChecked(item.id) || !item.required || !isTouched(item.id)">
            <app-show-more *ngIf="item.description!==null && item.description.length>0; else noMoreInfo"
                           (showEvent)="onShowEvent(i)">
              <ng-container
                id="{{'checkLabel_' + item.id}}"
                show-more-heading>
                {{ item.name }}
              </ng-container>
              <div show-more-body class="consent-description accent-color">
                {{ item.description }}
              </div>
            </app-show-more>
            <ng-template #noMoreInfo>
              <div class="html-statement" [innerHTML]="  item.name | safeHtml" style="text-align: justify"></div>
            </ng-template>
          </div>
        </div>
        <mat-error class="checkbox-container" *ngIf="!isChecked(item.id) && item.required && isTouched(item.id)">
          <span style="font-weight: 600">Wymagane</span>
        </mat-error>
      </div>

    </ng-container>
  </ng-container>

</div>
